<template>

    <m-edit1/>

    <m-un-authenticated-shopping-cart2 v-bind='{...{"EmptyCartImage":null,"instagramProp":false,"hideAddressDescription":true,"hideSignupButton":true,"presenterProp":false,"order_description_prop":true,"postal_code_prop":true,"codeMeliProp":false,"gradeProp":false,"orientationProp":false,"schoolNameProp":false,"classNameProp":false,"birthdayProp":false,"motherJobProp":false,"fatherJobProp":false,"registerRequestProp":false,"gradeSelectProp":false,"roundTripServiceProp":false,"shiftProp":false,"deliveryNewAddressProp":true,"deliveryDefaultAddressProp":true,"hideRefreshShoppingCartButton":true,"defaultGate":"","activeShoppingCartForm":false,"addressRequired":true,"setUnauthenticatedShoppingCartFromLoginUser":false,"advanceDescriptionInputs":"","advanceDescription":false,"showProductListProp":true,"orderDescriptionValueProp":"","disableSelectedCityWatch":true,"defaultLocation":true,"defaultCityId":"","defaultProvinceId":""},...{}}' :style='""' class="" >
                <template #default>default   </template>
                </m-un-authenticated-shopping-cart2><m-a v-bind='{...{"href":"{\"name\":\"Home\",\"params\":{}}","target":"_self"},...{}}' :style='""' class="" >
                <template #default>   <m-button-903 v-bind='{...{},...{}}' :style='""' class="bg-primary text-white shadow" >
                <template #default>   <m-icon v-bind='{...{"icon":"arrow-return-right"},...{}}' :style='""' class="" ></m-icon><m-p v-bind='{...{},...{}}' :style='"font-size:10px"' class="text-white" >
                <template #default>return   </template>
                </m-p></template>
                </m-button-903></template>
                </m-a>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mUnAuthenticatedShoppingCart2 from '@moeinmdn/miw-alpha-components/src/package/UnAuthenticatedShoppingCart/UnAuthenticatedShoppingCart2'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mButton903 from '@moeinmdn/miw-alpha-components/src/package/Buttons/Button903'; import mIcon from '@moeinmdn/miw-alpha-components/src/package/Icons/Icon'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P';

export default {
    name: 'HomeView',
    components: {mEdit1, mUnAuthenticatedShoppingCart2,mA,mButton903,mIcon,mP },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
